import React from 'react';
import { HomeTaskAttachments } from '@/components/HomeTaskModal/HomeTaskAttachments';
import { DETAILS_CARD } from '@/components/LessonDetailsModal/classNames';
import { LessonScheduledTest } from '@/components/LessonScheduledTest';
import type { Attachment } from '@/types/attachment';
import type { TextWithAttachments } from '@/types/diary';

interface Props {
  test: TextWithAttachments;
  onPreview: (attachment: Attachment) => void;
}

export const LessonScheduledTestCard: React.FC<Props> = ({
  test,
  onPreview,
}) => (
  <div className={`flex flex-col gap-3 ${DETAILS_CARD}`}>
    <LessonScheduledTest hasEmptyPlaceholder test={test} />
    <HomeTaskAttachments
      isFullWidth
      attachments={test.attachments}
      onPreview={onPreview}
    />
  </div>
);
